import { render } from "./banktab.vue?vue&type=template&id=001df81c"
import script from "./banktab.vue?vue&type=script&lang=js"
export * from "./banktab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__